import { render, staticRenderFns } from "./NestedLayers.vue?vue&type=template&id=bae57882&scoped=true&"
import script from "./NestedLayers.vue?vue&type=script&lang=ts&"
export * from "./NestedLayers.vue?vue&type=script&lang=ts&"
import style0 from "./NestedLayers.vue?vue&type=style&index=0&id=bae57882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae57882",
  null
  
)

export default component.exports